module.exports = __webpack_public_path__ + "static/media/sp45.f1099885.JPG";